export default defineNuxtRouteMiddleware((to) => {
  const snackbarStore = useSnackbarStore();
  const layoutStore = useLayoutStore();
  const { closeAll } = useNavigation();

  snackbarStore.removeAllButGlobalScope();

  if (to.path.includes("app")) {
    layoutStore.hideNavAndFooter();
  }

  closeAll();
});
